import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip, Button, Popover, SegmentedControl } from '@mantine/core'
import { IconLanguage } from '@tabler/icons-react'

const LanguageDropdown = () => {
  const { t, i18n } = useTranslation()
  const [currentLang, setCurrentLang] = useState(i18n.language)
  const languageNames =
    !!currentLang &&
    new Intl.DisplayNames([], {
      type: `language`,
    })
  const data = [
    {
      label: `🇬🇧 ` + (!!languageNames && languageNames.of(`en`)),
      value: `en-GB`,
    },

    {
      label: `🇳🇱 ` + (!!languageNames && languageNames.of(`nl`)),
      value: `nl-NL`,
    },
    {
      label: `🇩🇪 ` + (!!languageNames && languageNames.of(`de`)),
      value: `de-DE`,
    },
  ]

  // e.g. "EN" for en-GB
  const currentCode = currentLang?.slice(0, 2).toUpperCase()

  const onLanguageSwitch = (language: string) => {
    setCurrentLang(language)
    i18n.changeLanguage(language)
  }

  return (
    <Popover shadow="md" position="bottom-end">
      <Popover.Target>
        <Tooltip label={t(`global.language`)}>
          <Button
            variant="default"
            h={32}
            px="sm"
            leftSection={<IconLanguage size={18} />}
            aria-label={t(`global.language`)}
          >
            {currentCode}
          </Button>
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown p={0}>
        <SegmentedControl
          data={data}
          value={currentLang}
          onChange={onLanguageSwitch}
          orientation="vertical"
        />
      </Popover.Dropdown>
    </Popover>
  )
}

export default LanguageDropdown
